<template>
    <div id='main-container' class='container-fluid page'>
        <div class='row'>
            <div class='col-8 centered'>
                <h1 class='title'>
                    <slot name='title'></slot>
                </h1>
                <h2 class='subtitle'>
                    A très bientôt sur notre plateforme.
                </h2>
            </div>
        </div>
        <div class='row centered'>
            <div class='col-8 centered'>
                <action-btn @action='redirect'>
                    <template slot='label'>
                        <slot name='label'></slot>
                    </template>
                </action-btn>
            </div>
        </div>
    </div>
</template>

<script>
    import ActionBtn from '../button/actionBtn';

    export default {
        components: {ActionBtn},
        name: 'information-content',
        methods: {
            redirect: function () {
                this.$emit('redirect')
            }
        }
    }
</script>

<style scoped>
    #main-container {
        margin: 0px;
    }

    .title {
        margin-top: 2em;
    }

    .subtitle {
        margin-bottom: 2em;
    }
</style>



// WEBPACK FOOTER //
// src/components/layout/InformationContent.vue